import React from 'react'
import ReactDOM from 'react-dom'
import GoogleFontLoader from 'react-google-font-loader'
import { toast } from 'react-toastify'
import App from './App'
import './index.css'
import * as serviceWorker from './serviceWorker'

toast.configure({
  hideProgressBar: true,
  position: toast.POSITION.BOTTOM_RIGHT,
  style: {
    zIndex: 9999999999999999,
  },
})

ReactDOM.render(
  <>
    <GoogleFontLoader
      fonts={[
        {
          font: 'Roboto',
          weights: [300, 400, 500, 700],
        },
      ]}

      display="swap"

    />
    <App />
  </>
  , document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
